<template>
  <div>
    <div class="gdlr-core-pbf-wrapper" style="padding: 0px 0px 0px 0px;">
      <div class="gdlr-core-pbf-background-wrap" style="background-color: #161616;"></div>
      <div class="gdlr-core-pbf-wrapper-content gdlr-core-js">
        <div class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-pbf-wrapper-full-no-space">
          <div class="gdlr-core-pbf-element">
            <div class="gdlr-core-revolution-slider-item gdlr-core-item-pdlr gdlr-core-item-pdb"
                 style="padding-bottom: 0px;">
              <!-- START Homepage 2 REVOLUTION SLIDER 6.4.2 -->
              <p class="rs-p-wp-fix"></p>
              <rs-module-wrap id="rev_slider_2_1_wrapper" data-source="gallery"
                              style="background: transparent; padding: 0; margin: 0px auto; margin-top: 0; margin-bottom: 0;">
                <rs-module id="rev_slider_2_1" style="" data-version="6.4.2">
                  <rs-slides>
                    <rs-slide :data-key="'rs-' + index" data-title="Slide" data-in="o:0;" data-out="a:false;" v-for="(banner, index) in banners" :key="index" @click="showBanner(banner)" style="cursor: pointer;">
                      <img :src="banner.image" title="slider-1-bg-2" width="2057" height="1149"
                           class="rev-slidebg" data-no-retina=""/>
                      <!-- -->
<!--                      <a id="slider-2-slide-6-layer-2" class="rs-layer rev-btn" href="#/contact" target="_self"-->
<!--                         data-type="button" data-rsp_ch="on"-->
<!--                         data-xy="x:l,l,l,c;xo:933px,933px,397px,97px;yo:611px,611px,480px,336px;"-->
<!--                         data-text="w:normal;s:20,20,18,18;l:20,20,12,10;fw:500;" data-dim="minh:0px,0px,none,none;"-->
<!--                         data-padding="t:22,22,17,17;r:23,23,17,28;b:22,22,17,17;l:23,23,17,28;"-->
<!--                         data-frame_1="st:1350;sR:1350;" data-frame_999="o:0;st:w;sR:7350;"-->
<!--                         data-frame_hover="c:#1c1c1c;bgc:#fff;bor:0px,0px,0px,0px;bri:120%;"-->
<!--                         style="z-index: 8; background-color: #323232; font-family: Jost;">联系我们-->
<!--                        <i class="fa-long-arrow-right" style="margin-left: 11px; font-size: 22px;"></i></a>-->
                      <!-- -->
<!--                      <rs-layer id="slider-2-slide-6-layer-3" class="jost-font" data-type="text" data-rsp_ch="on"-->
<!--                                data-xy="x:l,l,c,c;xo:729px,729px,0,0;yo:184px,184px,202px,110px;"-->
<!--                                data-text="w:normal;s:123,123,79,43;l:123,123,93,52;fw:300,300,500,500;a:left,left,center,center;"-->
<!--                                data-dim="w:547px,547px,791px,425px;" data-frame_1="st:380;sR:380;"-->
<!--                                data-frame_999="o:0;st:w;sR:8320;" style="z-index: 12; font-family: Jost;">匯德香港-->
<!--                      </rs-layer>-->
                      <!-- -->
<!--                      <rs-layer id="slider-2-slide-6-layer-5" class="jost-font" data-type="text" data-rsp_ch="on"-->
<!--                                data-xy="x:l,l,c,c;xo:729px,729px,0,0;yo:502px,502px,367px,182px;"-->
<!--                                data-text="w:normal;s:21,21,20,16;l:35,35,35,27;ls:0,0,0,1px;a:left,left,center,center;"-->
<!--                                data-dim="w:482.6400000000001px,482.6400000000001px,482px,358px;"-->
<!--                                data-frame_1="st:870;sR:870;" data-frame_999="o:0;st:w;sR:7830;"-->
<!--                                style="z-index: 10; font-family: Jost;">匯德·德道信托高管参加两地媒体高度关注的香港深圳投资交流会-->
<!--                      </rs-layer>-->
                      <!-- -->
<!--                      <rs-layer id="slider-2-slide-6-layer-6" class="jost-font" data-type="text" data-rsp_ch="on"-->
<!--                                data-xy="x:l,l,c,c;xo:731px,731px,0,0;yo:120px,120px,139px,72px;"-->
<!--                                data-text="s:32,32,42,23;l:60,60,60,28;ls:0,0,0,1px;fw:300,300,300,700;a:left,left,left,center;"-->
<!--                                data-frame_1="st:120;sR:120;" data-frame_999="o:0;st:w;sR:8580;"-->
<!--                                style="z-index: 13; font-family: Jost;">匯德-->
<!--                      </rs-layer>-->
                      <!-- -->
<!--                      <rs-layer id="slider-2-slide-6-layer-7" data-type="shape" data-rsp_ch="on"-->
<!--                                data-xy="x:l,l,c,c;xo:733px,733px,0,0;yo:105px,105px,103px,38px;"-->
<!--                                data-text="w:normal;s:20,20,12,7;l:0,0,15,9;"-->
<!--                                data-dim="w:5px,5px,6px,5px;h:5px,5px,6px,5px;" data-border="bor:5px,5px,5px,5px;"-->
<!--                                data-frame_999="o:0;st:w;sR:8700;"-->
<!--                                style="z-index: 14; background-color: #d32525;"></rs-layer>-->
                      <!-- -->
<!--                      <a id="slider-2-slide-6-layer-8" class="rs-layer rev-btn" href="https://city.sina.cn/news/2023-07-14/detail-imzarqmv5181697.d.html"-->
<!--                         target="_self" data-type="button" data-rsp_ch="on"-->
<!--                         data-xy="x:l,l,l,c;xo:729px,729px,218px,-97px;yo:611px,611px,480px,336px;"-->
<!--                         data-text="w:normal;s:20,20,17,18;l:20,20,12,10;fw:500;" data-dim="minh:0px,0px,none,none;"-->
<!--                         data-padding="t:22,22,17,17;r:23,23,17,28;b:22,22,17,17;l:23,23,18,28;"-->
<!--                         data-frame_1="st:1120;sR:1120;" data-frame_999="o:0;st:w;sR:7580;"-->
<!--                         data-frame_hover="c:#d32525;bgc:#fff;bor:0px,0px,0px,0px;bri:120%;"-->
<!--                         style="z-index: 9; background-color: #d32525; font-family: Jost;">了解更多-->
<!--                        <i class="fa-long-arrow-right" style="margin-left: 11px; font-size: 22px;"></i></a>-->
                      <!-- -->
<!--                      <rs-layer id="slider-2-slide-6-layer-21" data-type="shape" data-rsp_ch="on"-->
<!--                                data-xy="x:l,l,c,c;xo:731px,731px,0,0;yo:454px,454px,322px,295px;"-->
<!--                                data-text="w:normal;s:20,20,12,7;l:0,0,15,9;"-->
<!--                                data-dim="w:45px,45px,60px,22px;h:2px,2px,5px,3px;" data-frame_1="st:660;sR:660;"-->
<!--                                data-frame_999="o:0;st:w;sR:8040;"-->
<!--                                style="z-index: 11; background-color: #d32525;"></rs-layer>-->
                      </rs-slide>
                  </rs-slides>
                  <rs-static-layers>
                    <!-- --></rs-static-layers>
                </rs-module>
              </rs-module-wrap>
              <!-- END REVOLUTION SLIDER --></div>
          </div>
        </div>
      </div>
    </div>

    <div class="gdlr-core-pbf-wrapper" style="padding: 0px 0px 0px 0px;">
      <div class="gdlr-core-pbf-background-wrap"></div>
      <div class="gdlr-core-pbf-wrapper-content gdlr-core-js">
        <div class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-pbf-wrapper-full-no-space">
          <div class="gdlr-core-pbf-column gdlr-core-column-60 gdlr-core-column-first" id="gdlr-core-column-54809">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js" style="margin: 0px -20px 0px -20px;">
              <div class="gdlr-core-pbf-background-wrap"></div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-feature-content-item gdlr-core-item-pdb clearfix gdlr-core-item-pdlr"
                       id="gdlr-core-feature-content-65970">
                    <div
                      class="gdlr-core-flexslider flexslider gdlr-core-js-2 gdlr-core-bullet-style-cylinder gdlr-core-style-3"
                      data-type="carousel" data-column="4" data-move="1" data-nav="bullet">
                      <ul class="slides">
                        <li class="gdlr-core-item-mglr">
                          <div class="gdlr-core-feature-content clearfix gdlr-core-left-align"
                               style="border-width: 0px 0px 0px 0px;">
                            <div class="gdlr-core-feature-content-thumbnail gdlr-core-media-image">
                              <img src="static/upload/img01-700x870.jpg" alt="" width="700" height="870" title="img01"/>
                            </div>
                            <div class="gdlr-core-feature-box-overlay"
                                 style="background: #000000; opacity: 0.01;"></div>
                            <div class="gdlr-core-feature-content-box gdlr-core-with-background"
                                 style="padding-right: 50px; padding-bottom: 40px; padding-left: 45px;">
                              <div class="gdlr-core-feature-content-caption gdlr-core-skin-info"
                                   style="color: #a5a5a5; font-size: 13px; font-weight: 500; letter-spacing: 0px; text-transform: none;">
                                01
                              </div>
                              <div class="gdlr-core-feature-content-title gdlr-core-title-font gdlr-core-skin-title"
                                   style="font-size: 29px; font-weight: 600; letter-spacing: 0px; text-transform: none;">
                                链接全球 遇见香港
                              </div>
                              <div class="gdlr-core-feature-content-wrap">
                                <div class="gdlr-core-feature-content-content gdlr-core-skin-content"
                                     style="font-size: 18px; font-weight: 400; letter-spacing: 0px; text-transform: none;">
                                  <p></p>
                                </div>
<!--                                <a class="gdlr-core-feature-content-learn-more" href="#/services/1"-->
<!--                                   style="text-transform: none;">Learn More-->
<!--                                  <i class="ion-ios-arrow-thin-right"></i></a>-->
                              </div>
                            </div>
                          </div>
                        </li>
                        <li class="gdlr-core-item-mglr">
                          <div class="gdlr-core-feature-content clearfix gdlr-core-left-align"
                               style="border-width: 0px 0px 0px 0px;">
                            <div class="gdlr-core-feature-content-thumbnail gdlr-core-media-image">
                              <img src="static/upload/column-top2-700x870.jpg" alt="" width="700" height="870"
                                   title="column top2"/></div>
                            <div class="gdlr-core-feature-box-overlay"
                                 style="background: #000000; opacity: 0.01;"></div>
                            <div class="gdlr-core-feature-content-box gdlr-core-with-background"
                                 style="padding-right: 50px; padding-bottom: 40px; padding-left: 45px;">
                              <div class="gdlr-core-feature-content-caption gdlr-core-skin-info"
                                   style="color: #a5a5a5; font-size: 13px; font-weight: 500; letter-spacing: 0px; text-transform: none;">
                                02
                              </div>
                              <div class="gdlr-core-feature-content-title gdlr-core-title-font gdlr-core-skin-title"
                                   style="font-size: 29px; font-weight: 600; letter-spacing: 0px; text-transform: none;">
                                一站式数字科技服务平台
                              </div>
                              <div class="gdlr-core-feature-content-wrap">
                                <div class="gdlr-core-feature-content-content gdlr-core-skin-content"
                                     style="font-size: 18px; font-weight: 400; letter-spacing: 0px; text-transform: none;">
                                  <p></p>
                                </div>
<!--                                <a class="gdlr-core-feature-content-learn-more" href="#/services/2"-->
<!--                                   style="text-transform: none;">Learn More-->
<!--                                  <i class="ion-ios-arrow-thin-right"></i></a>-->
                              </div>
                            </div>
                          </div>
                        </li>
                        <li class="gdlr-core-item-mglr">
                          <div class="gdlr-core-feature-content clearfix gdlr-core-left-align"
                               style="border-width: 0px 0px 0px 0px;">
                            <div class="gdlr-core-feature-content-thumbnail gdlr-core-media-image">
                              <img src="static/upload/column-top3-700x870.jpg" alt="" width="700" height="870"
                                   title="column top3"/></div>
                            <div class="gdlr-core-feature-box-overlay"
                                 style="background: #000000; opacity: 0.01;"></div>
                            <div class="gdlr-core-feature-content-box gdlr-core-with-background"
                                 style="padding-right: 50px; padding-bottom: 40px; padding-left: 45px;">
                              <div class="gdlr-core-feature-content-caption gdlr-core-skin-info"
                                   style="color: #a5a5a5; font-size: 13px; font-weight: 500; letter-spacing: 0px; text-transform: none;">
                                03
                              </div>
                              <div class="gdlr-core-feature-content-title gdlr-core-title-font gdlr-core-skin-title"
                                   style="font-size: 29px; font-weight: 600; letter-spacing: 0px; text-transform: none;">
                                专业团队 不忘初心
                              </div>
                              <div class="gdlr-core-feature-content-wrap">
                                <div class="gdlr-core-feature-content-content gdlr-core-skin-content"
                                     style="font-size: 18px; font-weight: 400; letter-spacing: 0px; text-transform: none;">
                                  <p></p>
                                </div>
<!--                                <a class="gdlr-core-feature-content-learn-more" href="#/services/3"-->
<!--                                   style="text-transform: none;">Learn More-->
<!--                                  <i class="ion-ios-arrow-thin-right"></i></a>-->
                              </div>
                            </div>
                          </div>
                        </li>
                        <li class="gdlr-core-item-mglr">
                          <div class="gdlr-core-feature-content clearfix gdlr-core-left-align"
                               style="border-width: 0px 0px 0px 0px;">
                            <div class="gdlr-core-feature-content-thumbnail gdlr-core-media-image">
                              <img src="static/upload/column-top4-700x870.jpg" alt="" width="700" height="870"
                                   title="column top4"/></div>
                            <div class="gdlr-core-feature-box-overlay"
                                 style="background: #000000; opacity: 0.01;"></div>
                            <div class="gdlr-core-feature-content-box gdlr-core-with-background"
                                 style="padding-right: 50px; padding-bottom: 40px; padding-left: 45px;">
                              <div class="gdlr-core-feature-content-caption gdlr-core-skin-info"
                                   style="color: #a5a5a5; font-size: 13px; font-weight: 500; letter-spacing: 0px; text-transform: none;">
                                04
                              </div>
                              <div class="gdlr-core-feature-content-title gdlr-core-title-font gdlr-core-skin-title"
                                   style="font-size: 29px; font-weight: 600; letter-spacing: 0px; text-transform: none;">
                                实力资质  服务无忧
                              </div>
                              <div class="gdlr-core-feature-content-wrap">
                                <div class="gdlr-core-feature-content-content gdlr-core-skin-content"
                                     style="font-size: 18px; font-weight: 400; letter-spacing: 0px; text-transform: none;">
                                  <p></p>
                                </div>
<!--                                <a class="gdlr-core-feature-content-learn-more" href="#/services/4"-->
<!--                                   style="text-transform: none;">Learn More-->
<!--                                  <i class="ion-ios-arrow-thin-right"></i></a>-->
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="gdlr-core-pbf-wrapper" style="padding: 90px 0px 90px 0px;">
      <div class="gdlr-core-pbf-background-wrap"></div>
      <div class="gdlr-core-pbf-background-wrap" style="top: 70px;">
        <div
          class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"
          style="background-image: url(upload/hp2-blog-bg.png); background-repeat: no-repeat; background-position: top center;"
          data-parallax-speed="0"
        ></div>
      </div>
      <div class="gdlr-core-pbf-wrapper-content gdlr-core-js">
        <div class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
          <div class="gdlr-core-pbf-column gdlr-core-column-60 gdlr-core-column-first" id="gdlr-core-column-53548">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js" style="padding: 0px 0px 15px 0px;">
              <div class="gdlr-core-pbf-background-wrap"></div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr">
                                                        <span
                                                          class="gdlr-core-title-item-caption gdlr-core-info-font gdlr-core-skin-caption"
                                                          style="font-size: 14px; font-weight: 500; font-style: normal; letter-spacing: 3px; text-transform: uppercase; color: #d32525;"
                                                        >
                                                            <span class="gdlr-core-title-item-caption-prefix" style="border-color: #d32525; height: 13px; margin-right: 14px;"></span>Industry insights
                                                        </span>
                    <div class="gdlr-core-title-item-title-wrap">
                      <h3 class="gdlr-core-title-item-title gdlr-core-skin-title" style="font-size: 42px; font-weight: 500; text-transform: none; color: #1b1b1b;">
                        动态<span class="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="gdlr-core-pbf-column gdlr-core-column-60 gdlr-core-column-first" data-skin="HP1 Blog" id="gdlr-core-column-96676">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js" style="margin: -90px 0px 0px 0px;">
              <div class="gdlr-core-pbf-background-wrap"></div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-blog-item gdlr-core-item-pdb clearfix gdlr-core-style-blog-column-with-frame gdlr-core-item-pdlr" style="padding-bottom: 0px;" id="gdlr-core-blog-9234">
                    <div class="gdlr-core-flexslider flexslider gdlr-core-js-2" data-type="carousel" data-column="3" data-move="1" data-nav="navigation-top" data-nav-parent="self">
                      <div class="gdlr-core-flexslider-custom-nav gdlr-core-style-navigation-top gdlr-core-right-align">
                        <i class="ion-ios-arrow-thin-left flex-prev" style="color: #c6c6c6; padding: 0px 10px 0px 10px; font-size: 50px;"></i>
                        <i class="ion-ios-arrow-thin-right flex-next" style="color: #c6c6c6; padding: 0px 10px 0px 10px; font-size: 50px;"></i>
                      </div>
                      <ul class="slides">
                        <li class="gdlr-core-item-mglr" v-for="news in newsList">
                          <div
                            class="gdlr-core-blog-grid gdlr-core-style-4 gdlr-core-js gdlr-core-left-button gdlr-core-blog-grid-with-frame gdlr-core-item-mgb gdlr-core-skin-e-background gdlr-core-outer-frame-element gdlr-core-with-thumbnail"
                            style="box-shadow: 0 20px 30px rgba(0, 0, 0, 0.06); -moz-box-shadow: 0 20px 30px rgba(0, 0, 0, 0.06); -webkit-box-shadow: 0 20px 30px rgba(0, 0, 0, 0.06);"
                            data-sync-height="blog-item-1"
                          >
                            <div class="gdlr-core-blog-thumbnail gdlr-core-media-image">
                              <a href="/#/" @click="openMedia(news)">
                                <img
                                  :src="news.image"
                                  alt=""
                                  width="600"
                                  height="600"
                                  :title="news.title"
                                />
                              </a>
                            </div>
                            <div class="gdlr-core-blog-grid-frame gdlr-core-sync-height-space-position clearfix"
                                 style="padding-right: 30px; padding-bottom: 40px;">
                              <div class="gdlr-core-blog-grid-top-info clearfix">
                                <span class="gdlr-core-blog-info gdlr-core-blog-info-font gdlr-core-skin-caption gdlr-core-blog-info-category">
                                  <span class="gdlr-core-head">
                                    <i class="icon_folder-alt"></i>
                                  </span>
<!--                                  <a :href="news.ads_id" rel="tag"></a>-->
<!--                                  <span class="gdlr-core-sep">,</span>-->
<!--                                  <a :href="news.ads_id" rel="tag"></a>-->
                                </span>
                                <span
                                  class="gdlr-core-blog-info gdlr-core-blog-info-font gdlr-core-skin-caption gdlr-core-blog-info-date">
                                  <span class="gdlr-core-head">
                                    <i class="icon_clock_alt"></i>
                                  </span>
                                  <a href="#">{{ showTime(news.extra.update_time) }}</a>
                                </span>
                              </div>
                              <h3 class="gdlr-core-blog-title gdlr-core-skin-title"
                                  style="font-size: 22px; font-weight: 500; letter-spacing: 0px;">
                                <a href="/#/" @click="openMedia(news)">{{ news.title }}</a>
                              </h3>
                              <div class="gdlr-core-blog-content clearfix"></div>
                              <!--                              <span class="gdlr-core-blog-info gdlr-core-blog-info-font gdlr-core-skin-caption gdlr-core-blog-info-author">-->
                              <!--                                                                                <span class="gdlr-core-head">By</span><a href="#" title="Posts by John Smith" rel="author">John Smith</a>-->
                              <!--                                                                            </span>-->
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
<!--          <div class="gdlr-core-pbf-column gdlr-core-column-60 gdlr-core-column-first" id="gdlr-core-column-99072">-->
<!--            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js" style="padding-top: 60px;">-->
<!--              <div class="gdlr-core-pbf-background-wrap"></div>-->
<!--              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js">-->
<!--                <div class="gdlr-core-pbf-element">-->
<!--                  <div class="gdlr-core-button-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-center-align" style="padding-bottom: 0px;">-->
<!--&lt;!&ndash;                    <a&ndash;&gt;-->
<!--&lt;!&ndash;                      class="gdlr-core-button gdlr-core-button-gradient gdlr-core-center-align gdlr-core-button-no-border"&ndash;&gt;-->
<!--&lt;!&ndash;                      href="blog-full-right-sidebar-with-frame.html"&ndash;&gt;-->
<!--&lt;!&ndash;                      style="&ndash;&gt;-->
<!--&lt;!&ndash;                                                                font-size: 16px;&ndash;&gt;-->
<!--&lt;!&ndash;                                                                font-weight: 700;&ndash;&gt;-->
<!--&lt;!&ndash;                                                                letter-spacing: 0px;&ndash;&gt;-->
<!--&lt;!&ndash;                                                                color: #ffffff;&ndash;&gt;-->
<!--&lt;!&ndash;                                                                padding: 3px 33px 3px 33px;&ndash;&gt;-->
<!--&lt;!&ndash;                                                                text-transform: none;&ndash;&gt;-->
<!--&lt;!&ndash;                                                                border-radius: 31px;&ndash;&gt;-->
<!--&lt;!&ndash;                                                                -moz-border-radius: 31px;&ndash;&gt;-->
<!--&lt;!&ndash;                                                                -webkit-border-radius: 31px;&ndash;&gt;-->
<!--&lt;!&ndash;                                                                background: #d32525;&ndash;&gt;-->
<!--&lt;!&ndash;                                                            "&ndash;&gt;-->
<!--&lt;!&ndash;                    >&ndash;&gt;-->
<!--&lt;!&ndash;                      <span class="gdlr-core-content">View All News</span><i class="gdlr-core-pos-right ion-ios-arrow-thin-right" style="font-size: 31px; color: #ffffff;"></i>&ndash;&gt;-->
<!--&lt;!&ndash;                    </a>&ndash;&gt;-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </div>
    </div>

    <!-- 关于 -->
    <div class="gdlr-core-pbf-wrapper" style="padding: 0px 0px 0px 0px;">
      <div class="gdlr-core-pbf-background-wrap" style="background-color: #f5f5f5;"></div>
      <div class="gdlr-core-pbf-background-wrap" style="top: 350px;">
        <div class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"
             style="background-image: url(static/upload/hp2-about-bg.png); background-repeat: no-repeat; background-position: top center;"
             data-parallax-speed="0"></div>
      </div>
      <div class="gdlr-core-pbf-wrapper-content gdlr-core-js">
        <div class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
          <div class="gdlr-core-pbf-column gdlr-core-column-30 gdlr-core-column-first" id="gdlr-core-column-2049">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js"
                 style="margin: 0px -30px 0px 0px; padding: 105px 40px 140px 0px;" data-sync-height="height-00">
              <div class="gdlr-core-pbf-background-wrap">
                <div class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"
                     style="background-image: url(static/upload/square00.png); background-size: cover; background-position: center;"
                     data-parallax-speed="0"></div>
              </div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js gdlr-core-sync-height-content">
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-image-item gdlr-core-item-pdb gdlr-core-center-align gdlr-core-item-pdlr"
                       style="padding-bottom: 0px;">
                    <div
                      class="gdlr-core-image-item-wrap gdlr-core-media-image gdlr-core-image-item-style-rectangle"
                      style="border-width: 0px;">
                      <img src="static/upload/talk-bg.jpg" alt="" width="601" height="398" title="talk bg"/></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="gdlr-core-pbf-column gdlr-core-column-30" id="gdlr-core-column-76282">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js"
                 style="margin: 0px 0px 0px 30px; padding: 115px 0px 0px 50px;" data-sync-height="height-00">
              <div class="gdlr-core-pbf-background-wrap">
                <div class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"
                     style="background-repeat: no-repeat; background-position: center;"
                     data-parallax-speed="0"></div>
              </div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js gdlr-core-sync-height-content">
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr">
                            <span class="gdlr-core-title-item-caption gdlr-core-info-font gdlr-core-skin-caption"
                                  style="font-size: 14px; font-weight: 500; font-style: normal; letter-spacing: 3px; text-transform: uppercase; color: #d32525;">
                              <span class="gdlr-core-title-item-left-dot"
                                    style="width: 5px; height: 5px; background-color: #d32525; margin-right: 13px;"></span>HUIDE GROUP</span>
                    <div class="gdlr-core-title-item-title-wrap">
                      <h3 class="gdlr-core-title-item-title gdlr-core-skin-title"
                          style="font-size: 44px; font-weight: 500; letter-spacing: 0px; text-transform: none; color: #090909;">
                        关于匯德
                        <span class="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span></h3>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align gdlr-core-no-p-space">
                    <div class="gdlr-core-text-box-item-content"
                         style="font-size: 18px; font-weight: 400; letter-spacing: 0px; text-transform: none; color: #090909;">
                      <p>
                        匯德·德道信托（简称“匯德香港”）致力于为全球企业、家族办公室及高净值客户提供全球化投资运营、法律架构、税收筹划、赛道投研分析、传承安排等一站式服务。
                      </p>
                      <br/>
                      <p>
                        目前，“匯德香港”总部设立于香港，在上海、深圳、新加坡、伦敦均设有办公室及战略合作机构。专业团队超70人，尤其拥有强大的法律及税务团队。成立至今，已为多个知名企业、投资机构的出境投资、信托搭建及管理、跨境资产配置提供了专业服务。主要针对VIE/红筹架构搭建、外汇备案、ODI等跨境并购业务提供一站式方案设计及运营管理。
                      </p>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-button-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align"
                       style="padding-bottom: 0px;">
                    <a
                      class="gdlr-core-button gdlr-core-button-transparent gdlr-core-left-align gdlr-core-button-no-border"
                      href="/#/" id="gdlr-core-button-id-7811">
                      <span class="gdlr-core-content">More About Us</span>
                      <i class="gdlr-core-pos-right fa fa-long-arrow-right"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="gdlr-core-pbf-column gdlr-core-column-60 gdlr-core-column-first" id="gdlr-core-column-68650">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js" style="padding: 0px 0px 70px 0px;">
              <div class="gdlr-core-pbf-background-wrap"></div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-divider-item gdlr-core-divider-item-normal gdlr-core-item-pdlr gdlr-core-center-align gdlr-core-style-vertical"
                    style="margin-bottom: 40px;">
                    <div class="gdlr-core-divider-line gdlr-core-skin-divider"
                         style="border-color: #d32525; border-width: 2px; border-radius: 0px; -moz-border-radius: 0px; -webkit-border-radius: 0px; height: 40px;"></div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-center-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr"
                    style="padding-bottom: 0px;">
                            <span class="gdlr-core-title-item-caption gdlr-core-info-font gdlr-core-skin-caption"
                                  style="font-size: 14px; font-weight: 500; font-style: normal; letter-spacing: 3px; text-transform: uppercase; color: #d32525; margin-bottom: 0px;">
                              <span class="gdlr-core-title-item-left-dot"
                                    style="width: 5px; height: 5px; background-color: #d32525; margin-right: 13px;"></span>HUIDE SERVICES</span>
                    <div class="gdlr-core-title-item-title-wrap">
                      <h3 class="gdlr-core-title-item-title gdlr-core-skin-title"
                          style="font-size: 44px; font-weight: 500; letter-spacing: 0px; text-transform: none; color: #353535;">
                        匯德服务
                        <span class="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span></h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 数字 -->
      <div class="gdlr-core-pbf-wrapper-content gdlr-core-js">
        <div class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
          <div class="gdlr-core-pbf-column gdlr-core-column-20 gdlr-core-column-first">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js">
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-counter-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align" style="padding-bottom: 5px;">
                    <div class="gdlr-core-counter-item-number gdlr-core-skin-title gdlr-core-title-font" style="font-size: 48px; font-weight: 500; margin-bottom: 0px;">
                      <span class="gdlr-core-counter-item-count gdlr-core-js" data-duration="" data-counter-start="0" data-counter-end="1000">0</span>
                      <span class="gdlr-core-counter-item-suffix">+</span>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr" style="padding-bottom: 50px;">
                    <div class="gdlr-core-title-item-title-wrap">
                      <h3 class="gdlr-core-title-item-title gdlr-core-skin-title" style="font-size: 24px; font-weight: 500; letter-spacing: 3px; color: #d32525;">
                        服务客户<span class="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-divider-item gdlr-core-divider-item-normal gdlr-core-item-pdlr gdlr-core-left-align" style="margin-bottom: 0px;">
                    <div class="gdlr-core-divider-container" style="max-width: 110px;">
                      <div
                        class="gdlr-core-divider-line gdlr-core-skin-divider"
                        style="border-color: #d32525; border-width: 3px; border-radius: 0px; -moz-border-radius: 0px; -webkit-border-radius: 0px;"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="gdlr-core-pbf-column gdlr-core-column-20">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js">
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-counter-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align" style="padding-bottom: 0px;">
                    <div class="gdlr-core-counter-item-number gdlr-core-skin-title gdlr-core-title-font" style="font-size: 48px; font-weight: 500; margin-bottom: 0px;">
                      <span class="gdlr-core-counter-item-count gdlr-core-js" data-duration="" data-counter-start="0" data-counter-end="100">0</span>
                      <span class="gdlr-core-counter-item-suffix">+</span>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr" style="padding-bottom: 50px;">
                    <div class="gdlr-core-title-item-title-wrap">
                      <h3 class="gdlr-core-title-item-title gdlr-core-skin-title" style="font-size: 24px; font-weight: 500; letter-spacing: 2px; color: #d32525;">
                        服务家办设立<span class="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-divider-item gdlr-core-divider-item-normal gdlr-core-item-pdlr gdlr-core-left-align" style="margin-bottom: 0px;">
                    <div class="gdlr-core-divider-container" style="max-width: 110px;">
                      <div
                        class="gdlr-core-divider-line gdlr-core-skin-divider"
                        style="border-color: #d32525; border-width: 3px; border-radius: 0px; -moz-border-radius: 0px; -webkit-border-radius: 0px;"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="gdlr-core-pbf-column gdlr-core-column-20">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js">
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-counter-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align" style="padding-bottom: 0px;">
                    <div class="gdlr-core-counter-item-number gdlr-core-skin-title gdlr-core-title-font" style="font-size: 48px; font-weight: 500; margin-bottom: 0px;">
                      <span class="gdlr-core-counter-item-count gdlr-core-js" data-duration="" data-counter-start="0" data-counter-end="50">0</span>
                      <span class="gdlr-core-counter-item-suffix">+</span>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr" style="padding-bottom: 50px;">
                    <div class="gdlr-core-title-item-title-wrap">
                      <h3 class="gdlr-core-title-item-title gdlr-core-skin-title" style="font-size: 24px; font-weight: 500; letter-spacing: 2px; color: #d32525;">
                        政府机构、银行、保司、券商等合作机构<span class="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-divider-item gdlr-core-divider-item-normal gdlr-core-item-pdlr gdlr-core-left-align" style="margin-bottom: 0px;">
                    <div class="gdlr-core-divider-container" style="max-width: 110px;">
                      <div
                        class="gdlr-core-divider-line gdlr-core-skin-divider"
                        style="border-color: #d32525; border-width: 3px; border-radius: 0px; -moz-border-radius: 0px; -webkit-border-radius: 0px;"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="height: 200px"></div>
    </div>

    <!-- 团队介绍 -->
<!--    <Team></Team>-->

    <!-- ext -->

<!--    <div class="gdlr-core-pbf-wrapper" style="padding: 0px 0px 90px 0px;">-->
<!--      <div class="gdlr-core-pbf-background-wrap">-->
<!--        <div class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"-->
<!--             style="background-image: url(static/upload/bg-frame-work.jpg); background-size: cover; background-position: center;"-->
<!--             data-parallax-speed="0"></div>-->
<!--      </div>-->
<!--      <div class="gdlr-core-pbf-wrapper-content gdlr-core-js">-->
<!--        <div class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">-->
<!--          <div class="gdlr-core-pbf-column gdlr-core-column-36 gdlr-core-column-first" id="gdlr-core-column-87150">-->
<!--            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js"-->
<!--                 style="margin: 0px 0px 0px 0px; padding: 135px 70px 0px 0px;">-->
<!--              <div class="gdlr-core-pbf-background-wrap"></div>-->
<!--              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js" style="max-width: 700px;">-->
<!--                <div class="gdlr-core-pbf-element">-->
<!--                  <div-->
<!--                    class="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr">-->
<!--                            <span class="gdlr-core-title-item-caption gdlr-core-info-font gdlr-core-skin-caption"-->
<!--                                  style="font-size: 14px; font-weight: 500; font-style: normal; letter-spacing: 3px; text-transform: uppercase; color: #d32525;">-->
<!--                              <span class="gdlr-core-title-item-left-dot"-->
<!--                                    style="width: 5px; height: 5px; background-color: #d32525; margin-right: 13px;"></span>Mission & Vision</span>-->
<!--                    <div class="gdlr-core-title-item-title-wrap">-->
<!--                      <h3 class="gdlr-core-title-item-title gdlr-core-skin-title"-->
<!--                          style="font-size: 42px; font-weight: 500; letter-spacing: 0px; text-transform: none; color: #ffffff;">-->
<!--                        使命与愿景-->
<!--                        <span class="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span></h3>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="gdlr-core-pbf-element">-->
<!--                  <div class="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align"-->
<!--                       style="padding-bottom: 20px;">-->
<!--                    <div class="gdlr-core-text-box-item-content"-->
<!--                         style="font-size: 24px; font-weight: 400; letter-spacing: 0px; text-transform: none; color: #a2a2a2;">-->
<!--                      <p>匯信天下 托之有道</p>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="gdlr-core-pbf-element">-->
<!--                  <div-->
<!--                    class="gdlr-core-icon-list-item gdlr-core-item-pdlr gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-style-1"-->
<!--                    style="padding-bottom: 0px;">-->
<!--                    <ul>-->
<!--                      <li class="gdlr-core-skin-divider clearfix">-->
<!--                                <span class="gdlr-core-icon-list-icon-wrap gdlr-core-left"-->
<!--                                      style="margin-top: 7px; margin-right: 10px;">-->
<!--                                  <i class="gdlr-core-icon-list-icon icon-check"-->
<!--                                     style="color: #d32525; font-size: 19px; width: 19px;"></i>-->
<!--                                </span>-->
<!--                        <div class="gdlr-core-icon-list-content-wrap">-->
<!--                              <span class="gdlr-core-icon-list-content"-->
<!--                                    style="color: #ffffff; font-size: 19px; font-weight: 500; text-transform: none; letter-spacing: 0px;">匯德集团专注于离岸架构的设计与咨询。我们认为离岸的本质是一种创新。这种创新可能是金融的、可能是税收的、可能是家族治理的，也可能是商业模式的，涉及企业与家族的方方面面，牵一发而动全身。因此，我们始终忠诚于我们的客户，忠诚于我们的使命。保障客户的基业长青，为中国的高净值家族提供隐私、传承和保全的解决方案是我们的立身之本。</span>-->
<!--                        </div>-->
<!--                      </li>-->
<!--                    </ul>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="gdlr-core-pbf-element">-->
<!--                  <div class="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align"-->
<!--                       style="padding-bottom: 20px;">-->
<!--                    <div class="gdlr-core-text-box-item-content"-->
<!--                         style="font-size: 24px; font-weight: 400; letter-spacing: 0px; text-transform: none; color: #a2a2a2;">-->
<!--                      <p>匯德使命</p>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="gdlr-core-pbf-element">-->
<!--                  <div-->
<!--                    class="gdlr-core-icon-list-item gdlr-core-item-pdlr gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-style-1"-->
<!--                    style="padding-bottom: 0px;">-->
<!--                    <ul>-->
<!--                      <li class="gdlr-core-skin-divider clearfix">-->
<!--                                <span class="gdlr-core-icon-list-icon-wrap gdlr-core-left"-->
<!--                                      style="margin-top: 7px; margin-right: 10px;">-->
<!--                                  <i class="gdlr-core-icon-list-icon icon-check"-->
<!--                                     style="color: #d32525; font-size: 19px; width: 19px;"></i>-->
<!--                                </span>-->
<!--                        <div class="gdlr-core-icon-list-content-wrap">-->
<!--                              <span class="gdlr-core-icon-list-content"-->
<!--                                    style="color: #ffffff; font-size: 19px; font-weight: 500; text-transform: none; letter-spacing: 0px;">让您的全球化发展更简单</span>-->
<!--                        </div>-->
<!--                      </li>-->
<!--                    </ul>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="gdlr-core-pbf-column gdlr-core-column-24" id="gdlr-core-column-69653">-->
<!--            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js"-->
<!--                 style="margin: -70px 0px 0px -30px; padding-top: 220px; padding-right: 0px; padding-bottom: 360px;">-->
<!--              <div class="gdlr-core-pbf-background-wrap">-->
<!--                <div class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"-->
<!--                     style="background-image: url(static/upload/column-frame.jpg); background-size: cover; background-position: center;"-->
<!--                     data-parallax-speed="0"></div>-->
<!--              </div>-->
<!--              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js"></div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

<!--    <Cooperation></Cooperation>-->

    <div v-if="showMedia" style="position: fixed; width: 100vw; height: 100%; background: rgba(0, 0, 0, 0.4); top: 0px; z-index: 1000; display: flex; flex-direction: row; justify-content: center; align-items: center;" @click="showMedia = !showMedia">
      <video controls="controls" autoplay="autoplay" style="width: 800px; height: 600px;">
        <source :src="videoUrl" type="video/mp4" />
      </video>
    </div>
  </div>
</template>

<script>
import Team from '@/components/Team'
// import Cooperation from '@/components/Cooperation'
import axios from 'axios'
export default {
  name: "Home",
  components: {
    Team// ,
    // Cooperation
  },
  data () {
    return {
      newsList: [],
      banners: [],
      showMedia: false,
      videoUrl: ''
    }
  },
  methods: {
    init() {
      var gdlr_core_pbf = {
        admin: "",
        video: {
          width: "640",
          height: "360"
        },
        ajax_url: "#"
      };
      /* ]]> */

      // <!-- Rev Slider Plugins Starts Here: -->

      function setREVStartSize(e) {
        //window.requestAnimationFrame(function() {
        window.RSIW = window.RSIW === undefined ? window.innerWidth : window.RSIW;
        window.RSIH = window.RSIH === undefined ? window.innerHeight : window.RSIH;
        try {
          var pw = document.getElementById(e.c).parentNode.offsetWidth,
            newh;
          pw = pw === 0 || isNaN(pw) ? window.RSIW : pw;
          e.tabw = e.tabw === undefined ? 0 : parseInt(e.tabw);
          e.thumbw = e.thumbw === undefined ? 0 : parseInt(e.thumbw);
          e.tabh = e.tabh === undefined ? 0 : parseInt(e.tabh);
          e.thumbh = e.thumbh === undefined ? 0 : parseInt(e.thumbh);
          e.tabhide = e.tabhide === undefined ? 0 : parseInt(e.tabhide);
          e.thumbhide = e.thumbhide === undefined ? 0 : parseInt(e.thumbhide);
          e.mh = e.mh === undefined || e.mh == "" || e.mh === "auto" ? 0 : parseInt(e.mh, 0);
          if (e.layout === "fullscreen" || e.l === "fullscreen") newh = Math.max(e.mh, window.RSIH);
          else {
            e.gw = Array.isArray(e.gw) ? e.gw : [e.gw];
            for (var i in e.rl) if (e.gw[i] === undefined || e.gw[i] === 0) e.gw[i] = e.gw[i - 1];
            e.gh = e.el === undefined || e.el === "" || (Array.isArray(e.el) && e.el.length == 0) ? e.gh : e.el;
            e.gh = Array.isArray(e.gh) ? e.gh : [e.gh];
            for (var i in e.rl) if (e.gh[i] === undefined || e.gh[i] === 0) e.gh[i] = e.gh[i - 1];

            var nl = new Array(e.rl.length),
              ix = 0,
              sl;
            e.tabw = e.tabhide >= pw ? 0 : e.tabw;
            e.thumbw = e.thumbhide >= pw ? 0 : e.thumbw;
            e.tabh = e.tabhide >= pw ? 0 : e.tabh;
            e.thumbh = e.thumbhide >= pw ? 0 : e.thumbh;
            for (var i in e.rl) nl[i] = e.rl[i] < window.RSIW ? 0 : e.rl[i];
            sl = nl[0];
            for (var i in nl) if (sl > nl[i] && nl[i] > 0) {
              sl = nl[i];
              ix = i;
            }
            var m = pw > e.gw[ix] + e.tabw + e.thumbw ? 1 : (pw - (e.tabw + e.thumbw)) / e.gw[ix];
            newh = e.gh[ix] * m + (e.tabh + e.thumbh);
          }
          if (window.rs_init_css === undefined) window.rs_init_css = document.head.appendChild(document.createElement("style"));
          document.getElementById(e.c).height = newh + "px";
          window.rs_init_css.innerHTML += "#" + e.c + "_wrapper { height: " + newh + "px }";
        } catch (e) {
          console.log("Failure at Presize of Slider:" + e);
        }
        //});
      }

      setREVStartSize({
        c: "rev_slider_2_1",
        rl: [1240, 1240, 778, 480],
        el: [860, 860, 700, 500],
        gw: [1280, 1280, 778, 480],
        gh: [860, 860, 700, 500],
        type: "standard",
        justify: "",
        layout: "fullwidth",
        mh: "0",
      });
      var revapi2, tpj;

      function revinit_revslider21() {
        jQuery(function () {
          tpj = jQuery;
          revapi2 = tpj("#rev_slider_2_1");
          if (revapi2 == undefined || revapi2.revolution == undefined) {
            revslider_showDoubleJqueryError("rev_slider_2_1");
          } else {
            revapi2.revolution({
              sliderLayout: "fullwidth",
              visibilityLevels: "1240,1240,778,480",
              gridwidth: "1280,1280,778,480",
              gridheight: "860,860,700,500",
              perspective: 600,
              perspectiveType: "local",
              editorheight: "860,768,700,500",
              responsiveLevels: "1240,1240,778,480",
              progressBar: {
                disableProgressBar: false
              },
              navigation: {
                wheelCallDelay: 1000,
                onHoverStop: false,
                touch: {
                  touchenabled: true,
                },
                arrows: {
                  enable: true,
                  style: "hesperiden",
                  hide_onleave: false
                },
                bullets: {

                  enable: true,
                  style: "hesperiden",
                  hide_onleave: false,
                  h_align: "center",
                  v_align: "bottom",
                  h_offset: 0,
                  v_offset: 20,
                  space: 5

                }
              },
              fallbacks: {
                allowHTML5AutoPlayOnAndroid: true,
              },
            });
          }
        });
      } // End of RevInitScript
      var once_revslider21 = false;
      if (document.readyState === "loading") {
        document.addEventListener("readystatechange",
          function () {
            if ((document.readyState === "interactive" || document.readyState === "complete") && !once_revslider21) {
              once_revslider21 = true;
              revinit_revslider21();
            }
          });
      } else {
        once_revslider21 = true;
        revinit_revslider21();
      }

      var htmlDivCss = unescape(".jost-font%7B%20font-family%3A%20%27jost%27%20%21important%3B%20%7D");
      var htmlDiv = document.getElementById("rs-plugin-settings-inline-css");
      if (htmlDiv) {
        htmlDiv.innerHTML = htmlDiv.innerHTML + htmlDivCss;
      } else {
        var htmlDiv = document.createElement("div");
        htmlDiv.innerHTML = "<style>" + htmlDivCss + "</style>";
        document.getElementsByTagName("head")[0].appendChild(htmlDiv.childNodes[0]);
      }

      var htmlDivCss = unescape("%0A%0A%0A%0A%0A%0A%0A%0A");
      var htmlDiv = document.getElementById("rs-plugin-settings-inline-css");
      if (htmlDiv) {
        htmlDiv.innerHTML = htmlDiv.innerHTML + htmlDivCss;
      } else {
        var htmlDiv = document.createElement("div");
        htmlDiv.innerHTML = "<style>" + htmlDivCss + "</style>";
        document.getElementsByTagName("head")[0].appendChild(htmlDiv.childNodes[0]);
      }

      if (typeof revslider_showDoubleJqueryError === "undefined") {
        function revslider_showDoubleJqueryError(sliderID) {
          var err = "<div class='rs_error_message_box'>"
          err += "<div class='rs_error_message_oops'>Oops...</div>"
          err += "<div class='rs_error_message_content'>"
          err += "You have some jquery.js library include that comes after the Slider Revolution files js inclusion.<br>"
          err += "To fix this, you can:<br>&nbsp;&nbsp;&nbsp; 1. Set 'Module General Options' -> 'Advanced' -> 'jQuery & OutPut Filters' -> 'Put JS to Body' to on"
          err += "<br>&nbsp;&nbsp;&nbsp; 2. Find the double jQuery.js inclusion and remove it"
          err += "</div>"
          err += "</div>"
          var slider = document.getElementById(sliderID)
          slider.innerHTML = err
          slider.style.display = 'block'
        }
      }
    },
    showTime(time) {
      let d = new Date(parseInt(time) * 1000)
      let year = d.getFullYear().toString()
      let month = (d.getMonth() + 1).toString()
      let day = d.getDate().toString()
      let hour = d.getHours().toString()
      let minute = d.getMinutes().toString()
      let second = d.getSeconds().toString()
      let date = year + '-' + month.padStart(2, '0') + '-' + day.padStart(2, '0') + ' ' + hour.padStart(2, '0') + ':' + minute.padStart(2, '0') + ':' + second.padStart(2, '0')
      let diff = ((new Date()).getTime() - d.getTime()) / 1000
      if (diff < 60) {
        return parseInt(diff) + '秒前'
      } else if (diff >= 60 && diff <= 3600) {
        return parseInt(diff / 60) + '分钟前'
      } else if (diff > 3600 && diff <= 3600 * 12) {
        return parseInt(diff / 3600) + '小时前'
      } else {
        return date
      }
    },
    openMedia (news) {
      if (news.type === 'wx') {
        // window.open('/#/news/media/' + news.param.media_id)
        window.open('https://www.huidetrust.com/service/user.do/news/media?media_id=' + news.param.media_id)
      } else {
        if (news.param.url !== '') {
          window.open(news.param.url)
        }
      }
    },
    getBanners () {
      this.newsList = JSON.parse(localStorage.getItem('newslist_1') || '[]')
      return axios.post('https://www.huidetrust.com/service/user.do/news/list', {
        page: 1,
        pageSize: 20,
        source: 'huide',
        position: '1'
      }).then(res => {
        this.banners = res.data.result.list
        localStorage.setItem('newslist_1', JSON.stringify(this.banners))
      })
    },
    getNewsList () {
      this.newsList = JSON.parse(localStorage.getItem('newslist_2') || '[]')
      return axios.post('https://www.huidetrust.com/service/user.do/news/list', {
        page: 1,
        pageSize: 20,
        source: 'huide',
        position: '2'
      }).then(res => {
        this.newsList = res.data.result.list
        localStorage.setItem('newslist_2', JSON.stringify(this.newsList))
      })
    },
    showBanner (item) {
      if (item.type === 'h5') {
        window.open(item.url)
      } else if (item.type === 'video') {
        this.videoUrl = item.param.url
        this.showMedia = true
      }
    }
  },
  mounted () {
    const p1 = this.getNewsList()
    const p2 = this.getBanners()
    Promise.all([p1, p2]).then(() => {
      setTimeout(() => {
        this.init()
      }, 100)
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Home.vue